/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OrdersPerDaySummary,
    OrdersPerDaySummaryFromJSON,
    OrdersPerDaySummaryFromJSONTyped,
    OrdersPerDaySummaryToJSON,
} from './';

/**
 * 
 * @export
 * @interface OrdersPerDaySummaryDataFrame
 */
export interface OrdersPerDaySummaryDataFrame {
    /**
     * 
     * @type {number}
     * @memberof OrdersPerDaySummaryDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof OrdersPerDaySummaryDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof OrdersPerDaySummaryDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<OrdersPerDaySummary>}
     * @memberof OrdersPerDaySummaryDataFrame
     */
    data: Array<OrdersPerDaySummary>;
}

export function OrdersPerDaySummaryDataFrameFromJSON(json: any): OrdersPerDaySummaryDataFrame {
    return OrdersPerDaySummaryDataFrameFromJSONTyped(json, false);
}

export function OrdersPerDaySummaryDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrdersPerDaySummaryDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(OrdersPerDaySummaryFromJSON)),
    };
}

export function OrdersPerDaySummaryDataFrameToJSON(value?: OrdersPerDaySummaryDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(OrdersPerDaySummaryToJSON)),
    };
}


